'use client'

import { AuthorizationContext, AuthorizedState } from '@entities/authentication'
import { useContext } from 'react'

export const useAuthorization = () => {
  const context = useContext(AuthorizationContext)

  if (!context) {
    throw new Error('useAuthorization must be used within a AuthorizationProvider')
  }

  return context as AuthorizedState
}
